module.exports = __webpack_public_path__ + "media/images/OPL 5-7591e7655b33ac0f37e36db70fdf8fce.png";